import AppProvider from 'components/AppProvider';
import { FormTemplatePreview } from 'components/models/FormTemplate';
import React from 'react';
import Content from './Content';
import { FormData } from './forms_table/FormsTable';
import HomeLayout, { HomeLayoutProps } from './HomeLayout';
import ConnectogramTGModal from './modals/ConnectogramTGModal';

interface PageProps {
  createNewFormUrl: string;
  enableShareToPg: boolean;
  enableSnaIntroModal: boolean;
  formsData: Array<FormData>;
  formTemplates: Array<FormTemplatePreview>;
  sideBarProps: HomeLayoutProps;
  userID: string;
}

export default function Page(props: PageProps): React.ReactElement {
  const { enableSnaIntroModal, sideBarProps, userID } = props;
  const { enableSna, formTemplatesUrl, snaUrl, insightsUrl } = sideBarProps;

  return (
    <AppProvider>
      <HomeLayout {...sideBarProps}>
        <Content
          enableSna={enableSna}
          formTemplatesUrl={formTemplatesUrl}
          insightsUrl={insightsUrl}
          snaUrl={snaUrl}
          {...props}
        />

        {renderFeaturesModal()}
      </HomeLayout>
    </AppProvider>
  );

  function renderFeaturesModal() {
    if (enableSna && enableSnaIntroModal) return <ConnectogramTGModal userID={userID} snaUrl={snaUrl} />;
    return null;
  }
}
